export enum ProviderRegistrationState {
  PendingSingUp = 1,
  PendingAproval = 2,
  RegistrationConfirmed = 3,
  UnregistrationRequested = 4,
  UnregistrationConfirmed = 5
};
